import { trpc } from "@/lib/trpc";
import { ticketsCheckoutEnabled } from "@/lib/eventCta";

/**
 * CHI-22: pricing mode per event slug, for list surfaces that only know
 * registrationMode. Reads the existing public events.publicPricingPolicy per
 * slug (cached by react-query); pass only slugs that could be paid.
 */
export function useEventPricingModes(slugs: readonly string[]): Map<string, string | null> {
  const results = trpc.useQueries(t => slugs.map(eventSlug => t.events.publicPricingPolicy({ eventSlug }, { retry: false })));
  const modes = new Map<string, string | null>();
  slugs.forEach((slug, index) => {
    const data = results[index]?.data as { pricingMode?: string | null } | null | undefined;
    modes.set(slug, data?.pricingMode ?? null);
  });
  return modes;
}

/**
 * CHI-20 kill switch for list surfaces (hero, calendar cards): true only when a policy for one of
 * these slugs says checkout is enabled (the flag is site-wide; any loaded policy carries it).
 * Same react-query cache entries as useEventPricingModes, so no extra requests.
 */
export function useTicketsCheckoutEnabled(slugs: readonly string[]): boolean {
  const results = trpc.useQueries(t => slugs.map(eventSlug => t.events.publicPricingPolicy({ eventSlug }, { retry: false })));
  return results.some(result => ticketsCheckoutEnabled(result?.data));
}
